import gql from 'graphql-tag';

export const GET_MARKETING_ONLY = gql`
  query getMarketingOnly($filter: MarketingOnlyFilter, $sort: [String], $search: String, $limit: Int, $pageNum: Int) {
    getMarketingOnly(filter: $filter, sort: $sort, search: $search, limit: $limit, pageNum: $pageNum) {
      Marketing_Only {
        id
        customer_id
        first_name_1
        last_name_1
        first_name_2
        last_name_2
        primary_email_1
        primary_email_2
        secondary_emails_1
        secondary_emails_2
        primary_email_1_status
        primary_email_2_status
        cell_phone_1
        cell_phone_2
        other_notes
        osc_notes
        division {
        id
        name
        }
        communities {
          id
          name
          is_active
        }
        customer_origination_area {
          id
          name
        }
        state {
          id
          name
        }
        zip
        street_address
        city
        created_at
        updated_at
      }
      total_count
    }
  }
`;

export const GET_MARKETING_ONLY_COUNT = gql`
  query getMarketingOnlyCount($input: MarketingOnlyCountFilter) {
    getTotalMarketingOnlyCount(filter: $input)
  }
`;

export const GET_DASHBOARD_MARKETING_ONLY = gql`
  query getDashboardMarketingOnly($input: MarketingOnlyFilter) {
    getMarketingOnly(filter: $input, limit: 1) {
      Marketing_Only {
        id
        first_name_1
        last_name_1
        communities {
          id
          name
          is_active
        }
        appointments {
          id
          title
          details
          appointment_purpose
          start_datetime
          end_datetime
          tentative_date
          zoom_meeting_link
          done
          createdAt
          Appointment_Type {
            id
            name
          }
          community {
            id
            name
            is_active
          }
          division {
            id
            name
          }
          csm {
            id
            first_name
            last_name
            is_active
          }
        }
        follow_ups {
          id
          title
          details
          done
          follow_up_datetime
          createdAt
          community {
            id
            name
            is_active
          }
          csm {
            id
            first_name
            last_name
            is_active
          }
        }
        walk_ins {
          id
          title
          details
          createdAt
          csm {
            id
            first_name
            last_name
            is_active
          }
        }
        phone_calls {
          phone_call_id
          session_id
          call_type {
            id
            name
          }
          call_details
          call_duration
          call_datetime
          attachments {
            id
            name
            type
            download_url
          }
        }
        emails {
          id
          subject
          body_preview
          date_time
          hasAttachments
          email_type
          to_recipients
          cc_recipients
          bcc_recipients
          isIndividual
          csms {
            id
            first_name
            last_name
            email_address
            cell_phone
            role
            createdAt
            updatedAt
            is_active
          }
        }
        traffic {
          id
          community {
            id
            name
            is_active
          }
          created_at
          traffic_type
          source
          traffic_date
        }
      }
      total_count
    }
  }
`;

export const GET_MARKETING_ONLY_DETAIL = gql`
  query getMarketingOnlyByFilter($limit: Int, $pageNum: Int, $filter: MarketingOnlyFilter, $search: String, $sort: [String]) {
    getMarketingOnly(limit: $limit, pageNum: $pageNum, filter: $filter, search: $search, sort: $sort) {
      Marketing_Only {
        id
        customer_id
        first_name_1
        last_name_1
        primary_email_1
        secondary_emails_1
        cell_phone_1
        first_name_2
        last_name_2
        primary_email_2
        secondary_emails_2
        primary_email_1_status
        primary_email_2_status
        cell_phone_2
        street_address
        city
        osc_notes
        form_submissions{
          form_submission_detail_id
          interested_in
          other_data
          response_phone
          response_sms
          response_email
          created_at
          updated_at
          responded_at
          response_medium
          domain
          url
          lot
          form_type
          url
          community{
            name
            is_active
          }
          responder{
            first_name
            last_name
          }
          division {
            id
            name
          }
        }
        customer_origination_area {
          id
          name
        }
        state {
          id
          name
        }
        zip
        other_notes
        communities {
          id
          name
          is_active
          division_id
        }

        division {
          id
          name
        }
        mailchimp_emails {
          mailchimp_email_id
          datetime
          subject
          email_addresses
          email_from
          content_url
          count
        }
        traffic {
          id
          community {
            id
            name
            is_active
          }
          created_at
          traffic_type
          source
          traffic_date
        }
        floor_plan_activities {
          id
          activity_type
          plan_name
          url
          saved_plan_configuration_id
          activity_datetime
          community {
            id
            name
            is_active
          }
          division {
            id
            name
          }
        }
        appointments {
          id
          title
          details
          appointment_purpose
          start_datetime
          end_datetime
          tentative_date
          zoom_meeting_link
          done
          createdAt
          Appointment_Type {
            id
            name
          }
          community {
            id
            name
            is_active
          }
          division {
            id
            name
          }
          csm {
            id
            first_name
            last_name
            is_active
          }
        }
        follow_ups {
          id
          title
          details
          done
          follow_up_datetime
          createdAt
          community {
            id
            name
            is_active
          }
          csm {
            id
            first_name
            last_name
            is_active
          }
        }
        walk_ins {
          id
          title
          details
          createdAt
          csm {
            id
            first_name
            last_name
            is_active
          }
        }
        phone_calls {
          phone_call_id
          session_id
          call_type {
            id
            name
          }
          call_details
          call_duration
          call_datetime
          attachments {
            id
            name
            type
            download_url
          }
        }
        emails {
          id
          subject
          body_preview
          date_time
          hasAttachments
          email_type
          to_recipients
          cc_recipients
          bcc_recipients
          isIndividual
          csms {
            id
            first_name
            last_name
            email_address
            cell_phone
            role
            createdAt
            updatedAt
            is_active
          }
        }
        notes {
          id
          description
          createdAt
          updatedAt
          is_osc
          creator {
            id
            first_name
            last_name
          }
          note_attachment {
            id
            file_path
            createdAt
            updatedAt
          }
        }
        created_at
        updated_at
      }
      total_count
    }
  }
`;

export const GET_MARKETING_ONLY_FILTERS = gql`
  query {
    getMarketingOnlyFilters {
      id
      filter_name
    }
  }
`;

export const GET_MARKETING_ONLY_FILTER_BY_ID = gql`
  query getMarketingOnlyFilters($input: Int) {
    getMarketingOnlyFilter(id:$input) {
      id
      filter_name
      created_from
      created_to
      phone
      note
      State {
        id
        name
      }
      Customer_Origination_Area {
        id
        name
      }
    }
  }
`;